export const mockAddress = {
  zip_code: '12008',
  zipcode: '12008',
  county_display: 'Schenectady',
  county_name: 'Schenectady',
  county: '36093',
  state_name: 'New York',
  state: 'NY',
};
